import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {

  @Input()
  iEmpty = false;

  @Input()
  iFirst = false;

  @Input()
  iLast = false;

  @Input()
  iNumber: number = 0;

  @Input()
  iTotalPages: number = 0;

  @Input()
  iTotalItems?: number;

  @Input()
  iItemLabel = 'élément';

  @Input()
  iPageSize?: number;

  @Output() currentPageChanged: EventEmitter<number> = new EventEmitter();



  constructor() { }

  ngOnInit(): void {
  }

  get currentPageDisplay(): number {
    return this.iTotalPages === 0 ? 0 : this.iNumber + 1;
  }

  get totalItemsLabel(): string {
    if (this.iTotalItems == null) {
      return '';
    }

    if (this.iTotalItems === 1) {
      return this.iItemLabel;
    }

    return this.iItemLabel.endsWith('s') ? this.iItemLabel : `${this.iItemLabel}s`;
  }

  get pageSizeLabel(): string {
    if (this.iPageSize == null) {
      return '';
    }

    return `${this.iPageSize} par page`;
  }

  changePage(page: string): void {
    let pageNumber = this.iNumber;
    switch (page) {
      case 'first': pageNumber = 0; break;
      case 'previous': pageNumber -= 1; break;
      case 'next': pageNumber += 1; break;
      case  'last': pageNumber = this.iTotalPages-1;
    }
    this.currentPageChanged.emit(pageNumber);
  }
}
